// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","BoldHeading":"BoldHeading-4schpz8ugw6n51yw9t4919nn598xd1qpru1zutnq7sp3j5h34k1d21th65mg1hhbe34wyjnwwx29wjf278uxav2538jpdeev4vaxjst","RodoPolicyContent":"RodoPolicyContent-2jud7921a6c5nfj9wdthyp5yhe3ydggz69j3s5jge48rartzqcdn39v5fpt31zcc7p5ud8u4mhtrr4p8ehs29tgp6av1wpbxbdx9cwt","loading":"loading-aj92456g7pbwpxb1dt5jk31ujh6718d83gh81mvwfagnvgjd5nwqsmkk68suz5k76s1msxbvng227fup44tg78w6mx7up5m7xrsc5h","pulse":"pulse-wscgmkzae46jvtn7t47gyjzs3su7cpv3v21hcnw1q7vwhn6wbyt5hwyzn74tk13ctghf6gssmws5j5pw65dnqm2d6g18ch4gj5w621"};


//////////////////
// WEBPACK FOOTER
// ./src/views/ZszPolicy/ZszPolicy.module.scss
// module id = 1794
// module chunks = 0